'use strict';
var bookFlightManagerModel = require('../modules/models/book_flight_manager').default;
Odigeo.defineWidget('book_room_manager', Odigeo.Widget.extend({
    modelClass: bookFlightManagerModel.extend({
        dataURL: 'accommodationpostbooking/createshoppingbasketaccommodation',
        hideLoading: Odigeo._.noop,

        getBookedRoom: function(data) {
            this.isEmptyData = false;
            this.cancelBookedFlight();
            this.lastShoppingCart = this.clear().save(data, {
                success: Odigeo._.bind(this.requestSuccessHandler, this),
                error: Odigeo._.bind(this.requestErrorHandler, this),
            });
        },

        requestSuccessHandler: function(model, msg) {
            if (msg.errors) {
                var error = msg.errors[0];
                if (error.code === 'SESSION_EXPIRED_ERROR' || error.code === 'SEARCH_EXPIRED_ERROR') {
                    Odigeo.UIElements.showSearchExpiredErrorAccommodationPB();
                } else if ((Odigeo.Utils.startsWith(error.message, this.selectionAccommodationProductErrorMessage) ||
                    Odigeo.Utils.startsWith(error.message, this.specifiedAccommodationKeyDifferentFromPreviouslySelectedCode))) {
                    Odigeo.trigger(this.widget.id + ':selectionAccommodationProductError', {
                        accommodationDealKey: this.widget.model.get('accommodationDealKey'),
                        roomGroupDealKey: this.widget.model.get('roomGroupDealKey'),
                    });
                } else {
                    Odigeo.UIElements.showBrokenFlowError();
                }
            } else {
                Odigeo.Utils.sessionTimer.reset();
                Odigeo.trigger(this.widget.id + ':shoppingBasketCreated', Odigeo._.omit(msg, 'errors'));
            }
        },

        requestErrorHandler: function(model, xhr) {
            if (!this.isEmptyData) {
                this.isEmptyData = true;
                Odigeo.UIElements.showBrokenFlowError();
            }
        },
    }),

    bookRoomHandler: function(data) {
        this.model.getBookedRoom(data);
        return true;
    },

    cancelBookFlightHandler: function() {
        this.model.cancelBookedFlight();
    },

    isShopingCartExecuted: function() {
        return !Odigeo._.isNull(this.model.lastShoppingCart);
    },

    selectionAccommodationProductErrorMessage: function() {
        return this.model.selectionAccommodationProductErrorMessage;
    },

    getSpecifiedAccommodationKeyDifferentFromPreviouslySelectedCode: function() {
        return this.model.specifiedAccommodationKeyDifferentFromPreviouslySelectedCode;
    },
}));
